module.exports = __webpack_public_path__ + "static/img/primary-pc.caeede80.png";